import { Button, LuIcon } from "@overmap-ai/blocks"
import { Link } from "@tanstack/react-router"
import { memo } from "react"

import { modelIconMapping } from "../../mappings/icons"
import { BaseTopBar } from "../TopBars/BaseTopBar"

export const AssetTypeDetailViewTopBar = memo(() => {
	return (
		<BaseTopBar
			leftContent={
				<Link
					from="/$organizationId/$projectId/asset-types/$assetTypeId/"
					to="/$organizationId/$projectId/asset-types"
				>
					<Button variant="ghost" accentColor="base">
						<LuIcon icon={modelIconMapping.arrowLeft} />
						Assets
					</Button>
				</Link>
			}
		/>
	)
})
AssetTypeDetailViewTopBar.displayName = "AssetTypeDetailViewTopBar"
